export const CARD_IMAGE_WIDTH = "300px";
export const CARD_IMAGE_WIDTH_THUMBNAIL = "117px";
export const CARD_IMAGE_HEIGHT = "169px";
export const CARD_IMAGE_HEIGHT_THUMBNAIL = "66px";
export const CARD_NO_IMAGE_HEIGHT = "122px";
export const CARD_NO_IMAGE_HEIGHT_THUMBNAIL = "50px";

export const CARD_IMAGE_SETTINGS = {
  minWidth: 300,
  maxWidth: 300,
  height: 360,
  maxHeight: 360,
  margin: 1,
  border: "1px solid hsl(from var(--colorBorder) h s 88%)",
};

export const CARD_NO_IMAGE_SETTINGS = {
  minWidth: 300,
  maxWidth: 300,
  height: 270,
  maxHeight: 270,
  margin: 1,
  border: "1px solid hsl(from var(--colorBorder) h s 88%)",
};

export const PROGRAM_ACTIVITY_IMAGE = "./Content/img/neutral.jpg";
export const PROGRAM_COURSE_IMAGE = "./Content/img/neutral.jpg";
export const PROGRAM_COURSE_IMAGE_PORTALOVERVIEW = "../Content/img/neutral.jpg";
export const PROGRAM_COURSE_IMAGE_BLANK_PORTALOVERVIEW =
  "../Content/img/neutral.jpg";
export const PROGRAM_SURVEY_IMAGE = "./Content/img/programStepSurvey.jpg";
export const PROGRAM_COURSE_IMAGE_BLANK = "./Content/img/neutral.jpg";

export const PROGRAM_TYPE_ONLINE = "Online";
export const PROGRAM_TYPE_CLASSROOM = "Classroom";
export const COURSE_TYPE_ONLINE = 1;
export const COURSE_TYPE_CLASSROOM = 2;
export const COURSE_TYPE_ACTIVITY = "Activity";
export const COURSE_TYPE_COMMON_ACTIVITY = "CommonActivity";
export const COURSE_TYPE_NEW_COMMON_ACTIVITY = "NewCommonActivity";
export const COURSE_TYPE_PROGRAM = "Program";
export const COURSE_TYPE_SURVEY_TO_COMPLETE = "SurveyToComplete";
